class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.headerSection = document.querySelector('.section-header');
    this.header = document.querySelector('.header-wrapper');
    this.stickyHeader = document.querySelector('.section-header sticky-header')
    this.details = this.querySelector('details')

    this.addEventListener('mouseenter', this.open.bind(this))
    this.addEventListener('mouseleave', this.close.bind(this))
  }

  open(e) {
    if (e.target == this) {
      this.details.open = true
    }
  }

  close(e) {
    // The journey disclosure also closes via inherited focus-out (no event).
    if (this.hasAttribute('data-sown-journey')) {
      if (e?.type === 'mouseleave' && this.contains(document.activeElement)) return;
      if (!e || !this.details.contains(e.target)) {
        this.details.open = false;
        this.details.querySelector('summary').setAttribute('aria-expanded', 'false');
      }
      return;
    }
    if (!this.details.contains(e.target)) {
      this.details.open = false
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    this.headerSection.classList.toggle('menu-is-open', this.mainDetailsToggle.open)

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
